export function importCodes(value: string) {
  return value
    .split(/[,\n]/)
    .map((v) => v.trim())
    .filter(Boolean);
}
export function importPollingInterval(status: string | undefined, started: number, now = Date.now()): number | false {
  return status && ['queued', 'claimed', 'retryable_failed'].includes(status) && now - started < 600000 ? 5000 : false;
}
export function newSelectionPayload(
  kind: 'place-mappings' | 'hotel-memberships',
  geo: string,
  target: string,
  enabled: boolean,
  reason: string,
  rank = 0,
) {
  if (
    !geo ||
    !target ||
    !reason.trim() ||
    reason.trim().length > 512 ||
    !Number.isSafeInteger(rank) ||
    rank < 0 ||
    rank > 2147483647
  ) throw new Error('Invalid new selection');
  return {
    geo_place_id: geo,
    enabled,
    reason: reason.trim(),
    expected_version: 0,
    ...(kind === 'place-mappings' ? { source: 'ubikeishon', place_id: target } : { hotel_id: target, rank }),
  };
}

/** Explicit supplier codes only: preserve case and leading zeroes. */
export function hotelCodeBatch(value: string, direct = false) {
  const entries = importCodes(value);
  const codes = [...new Set(entries)].sort();
  return {
    codes,
    duplicates: entries.length - codes.length,
    valid:
      codes.length > 0 &&
      codes.length <= 20 &&
      codes.every(
        (code) =>
          (!direct || /^[1-9]\d*$/.test(code)) &&
          code.length <= 512 &&
          !/\s/.test(code) &&
          Array.from(code).every((char) => char.charCodeAt(0) >= 32 && char.charCodeAt(0) !== 127),
      ),
  };
}
export function isHotelCodeImport(job: { content_kind: string; criteria: Record<string, unknown> }) {
  const c = job.criteria;
  return (
    job.content_kind === 'supplier_hotel_list' &&
    Array.isArray(c.hotel_codes) &&
    c.hotel_codes.length > 0 &&
    c.hotel_codes.length <= 20 &&
    c.hotel_codes.every((code) => typeof code === 'string') &&
    ['countries', 'destination_codes', 'category_codes'].every(
      (key) => Array.isArray(c[key]) && (c[key] as unknown[]).length === 0,
    ) &&
    c.group === null
  );
}
